module.exports = __webpack_public_path__ + "static/media/IconArrowUp.d263ecf7.svg";